// import React, {
//   useState,
//   useEffect,
//   forwardRef,
//   useImperativeHandle,
// } from "react";
// import {
//   Box,
//   Button,
//   Container,
//   Grid,
//   InputLabel,
//   TextField,
//   Typography,
//   useTheme,
// } from "@mui/material";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import Loader from "../loader/Loader";
// const CryptoJS = require("crypto-js");

// const AppEmployeeWorkExperience = forwardRef(({ initialData = {} }, ref) => {
//   const theme = useTheme();
//   const isDarkMode = theme.palette.mode === "dark";

//   const [employeeWorkExperience, setEmployeeWorkExperience] = useState({
//     employee_id: initialData.employee_id || "",
//     previous_2employers_exprience_certificate: null,
//     professional_reference1: "",
//     professional_reference1_contact_number: "",
//     professional_reference2: "",
//     professional_reference2_contact_number: "",
//     skill_sets: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");

//   useEffect(() => {
//     if (initialData) {
//       setEmployeeWorkExperience((prev) => ({
//         ...prev,
//         ...initialData,
//         employee_id: initialData.employee_id || prev.employee_id,
//       }));
//     }
//   }, [initialData]);

//   const handleChange = (e) => {
//     const { name, value, files } = e.target;
//     setEmployeeWorkExperience((prev) => ({
//       ...prev,
//       [name]: files ? files[0] : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e?.preventDefault?.(); // support both programmatic and form submission
//     setSuccessMessage("");
//     setErrorMessage("");
//     setLoading(true);

//     try {
//       const encryptedapikey = sessionStorage.getItem("encrypted_data");
//       const base64Key = sessionStorage.getItem("base64_Key");
//       let decryptedjwt = "";

//       if (base64Key && encryptedapikey) {
//         const key = CryptoJS.enc.Base64.parse(base64Key);
//         const dataBytes = CryptoJS.enc.Base64.parse(encryptedapikey);
//         const iv = CryptoJS.lib.WordArray.create(dataBytes.words.slice(0, 4));
//         const ciphertext = CryptoJS.lib.WordArray.create(
//           dataBytes.words.slice(4)
//         );
//         const decryptedBytes = CryptoJS.AES.decrypt(
//           { ciphertext },
//           key,
//           { iv }
//         );
//         decryptedjwt = CryptoJS.enc.Utf8.stringify(decryptedBytes);
//       }

//       const formData = new FormData();
//       for (const key in employeeWorkExperience) {
//         formData.append(key, employeeWorkExperience[key]);
//       }
//       const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
//       const response = await fetch(
//         `${process.env.REACT_APP_BACKEND_URL_HRM}/add-employee-work-experience`,
//         {
//           method: "POST",
//           headers: { "X-API-Key": decryptedjwt },
//           body: formData,
//           'Authorization': `Bearer ${accessToken}`
//         }
//       );

//       const data = await response.json();

//       if (response.status === 401) {
//         setErrorMessage(data.error);
//       } else if (response.ok) {
//         setSuccessMessage(data.message);
//         setEmployeeWorkExperience((prev) => ({
//           ...prev,
//           previous_2employers_exprience_certificate: null,
//           professional_reference1: "",
//           professional_reference1_contact_number: "",
//           professional_reference2: "",
//           professional_reference2_contact_number: "",
//           skill_sets: "",
//         }));
//       } else {
//         throw new Error("Network error");
//       }
//     } catch (err) {
//       console.error(err);
//       setErrorMessage("An error occurred while submitting work experience.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useImperativeHandle(ref, () => ({
//     handleSubmit,
//   }));

//   return (
//     <Container maxWidth="md">
//       {loading && (
//         <Box
//           sx={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             background: "rgba(0, 0, 0, 0.5)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 1000,
//           }}
//         >
//           <Loader />
//         </Box>
//       )}

//       <Box
//         sx={{
//           backgroundColor: isDarkMode ? "background.default" : "white",
//           padding: 4,
//           mt: 5,
//         }}
//       >
//         <Typography
//           variant="h5"
//           textAlign="center"
//           sx={{
//             mb: 2,
//             fontWeight: "bold",
//             color: isDarkMode ? "text.primary" : "black",
//           }}
//         >
//           Add Work Experience
//         </Typography>

//         <form onSubmit={handleSubmit}>
//           <Grid container spacing={2} direction="column">
//             <Grid item xs={12}>
//               <InputLabel
//                 sx={{
//                   fontWeight: "bold",
//                   color: isDarkMode ? "text.primary" : "black",
//                 }}
//               >
//                 Upload Last 2 Employers' Experience Certificates
//               </InputLabel>
//               <Button
//                 component="label"
//                 variant="contained"
//                 startIcon={<CloudUploadIcon />}
//                 fullWidth
//                 sx={{
//                   textTransform: "none",
//                   backgroundColor: isDarkMode ? "#4caf50" : "#1976d2",
//                   color: "white",
//                   "&:hover": {
//                     backgroundColor: isDarkMode ? "#388e3c" : "#1565c0",
//                   },
//                 }}
//               >
//                 Upload File
//                 <input
//                   type="file"
//                   name="previous_2employers_exprience_certificate"
//                   hidden
//                   onChange={handleChange}
//                 />
//               </Button>
//               {employeeWorkExperience.previous_2employers_exprience_certificate && (
//                 <Typography variant="body2" sx={{ color: "green", mt: 1 }}>
//                   Selected:{" "}
//                   {employeeWorkExperience.previous_2employers_exprience_certificate.name}
//                 </Typography>
//               )}
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 label="Professional Reference 1"
//                 name="professional_reference1"
//                 value={employeeWorkExperience.professional_reference1}
//                 onChange={handleChange}
//                 fullWidth
//                 InputLabelProps={{
//                   shrink: true,
//                   sx: {
//                     color: theme.palette.mode === "dark" ? "#fff" : "inherit",
//                     "&.Mui-focused": {
//                       color: theme.palette.mode === "dark" ? "#fff" : theme.palette.primary.main,
//                     },
//                   },
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     borderRadius: 2,
//                     backgroundColor:
//                       theme.palette.mode === "dark" ? "" : theme.palette.background.default,
//                     color: theme.palette.text.primary,
              
//                     "&.Mui-focused": {
//                       backgroundColor: theme.palette.mode === "dark" ? "hsla(180, 17.20%, 25.10%, 0.92)" : "#f5f5f5",
//                     },
              
//                     "& fieldset": {
//                       borderColor:
//                         theme.palette.mode === "dark"
//                           ? ""
//                           : "#ccc",
//                     },
//                     "&:hover fieldset": {
//                       borderColor: theme.palette.primary.main,
//                     },
//                     "&.Mui-focused fieldset": {
//                       borderColor: theme.palette.mode === "dark" ? "white" : "#f5f5f5",
//                     },
//                   },
//                   "& .MuiInputBase-input": {
//                     color: theme.palette.text.primary,
//                   },
//                 }}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 label="Reference 1 Contact Number"
//                 name="professional_reference1_contact_number"
//                 value={employeeWorkExperience.professional_reference1_contact_number}
//                 onChange={handleChange}
//                 fullWidth
//                 required
//                 InputLabelProps={{
//                   shrink: true,
//                   sx: {
//                     color: theme.palette.mode === "dark" ? "#fff" : "inherit",
//                     "&.Mui-focused": {
//                       color: theme.palette.mode === "dark" ? "#fff" : theme.palette.primary.main,
//                     },
//                   },
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     borderRadius: 2,
//                     backgroundColor:
//                       theme.palette.mode === "dark" ? "" : theme.palette.background.default,
//                     color: theme.palette.text.primary,
              
                    
//                     "&.Mui-focused": {
//                       backgroundColor: theme.palette.mode === "dark" ? "hsla(180, 17.20%, 25.10%, 0.92)" : "#f5f5f5",
//                     },
              
//                     "& fieldset": {
//                       borderColor:
//                         theme.palette.mode === "dark"
//                           ? ""
//                           : "#ccc",
//                     },
//                     "&:hover fieldset": {
//                       borderColor: theme.palette.primary.main,
//                     },
//                     "&.Mui-focused fieldset": {
//                       borderColor: theme.palette.mode === "dark" ? "white" : "#f5f5f5",
//                     },
//                   },
//                   "& .MuiInputBase-input": {
//                     color: theme.palette.text.primary,
//                   },
//                 }}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 label="Professional Reference 2"
//                 name="professional_reference2"
//                 value={employeeWorkExperience.professional_reference2}
//                 onChange={handleChange}
//                 fullWidth
//                 required
//                 InputLabelProps={{
//                   shrink: true,
//                   sx: {
//                     color: theme.palette.mode === "dark" ? "#fff" : "inherit",
//                     "&.Mui-focused": {
//                       color: theme.palette.mode === "dark" ? "#fff" : theme.palette.primary.main,
//                     },
//                   },
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     borderRadius: 2,
//                     backgroundColor:
//                       theme.palette.mode === "dark" ? "" : theme.palette.background.default,
//                     color: theme.palette.text.primary,
              
              
//                     "&.Mui-focused": {
//                       backgroundColor: theme.palette.mode === "dark" ? "hsla(180, 17.20%, 25.10%, 0.92)" : "#f5f5f5",
//                     },
              
//                     "& fieldset": {
//                       borderColor:
//                         theme.palette.mode === "dark"
//                           ? ""
//                           : "#ccc",
//                     },
//                     "&:hover fieldset": {
//                       borderColor: theme.palette.primary.main,
//                     },
//                     "&.Mui-focused fieldset": {
//                       borderColor: theme.palette.mode === "dark" ? "white" : "#f5f5f5",
//                     },
//                   },
//                   "& .MuiInputBase-input": {
//                     color: theme.palette.text.primary,
//                   },
//                 }}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 label="Reference 2 Contact Number"
//                 name="professional_reference2_contact_number"
//                 value={employeeWorkExperience.professional_reference2_contact_number}
//                 onChange={handleChange}
//                 fullWidth
//                 required
//                 InputLabelProps={{
//                   shrink: true,
//                   sx: {
//                     color: theme.palette.mode === "dark" ? "#fff" : "inherit",
//                     "&.Mui-focused": {
//                       color: theme.palette.mode === "dark" ? "#fff" : theme.palette.primary.main,
//                     },
//                   },
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     borderRadius: 2,
//                     backgroundColor:
//                       theme.palette.mode === "dark" ? "" : theme.palette.background.default,
//                     color: theme.palette.text.primary,
              
//                     // Active (focused) background color change
//                     "&.Mui-focused": {
//                       backgroundColor: theme.palette.mode === "dark" ? "hsla(180, 17.20%, 25.10%, 0.92)" : "#f5f5f5",
//                     },
              
//                     "& fieldset": {
//                       borderColor:
//                         theme.palette.mode === "dark"
//                           ? ""
//                           : "#ccc",
//                     },
//                     "&:hover fieldset": {
//                       borderColor: theme.palette.primary.main,
//                     },
//                     "&.Mui-focused fieldset": {
//                       borderColor: theme.palette.mode === "dark" ? "white" : "#f5f5f5",
//                     },
//                   },
//                   "& .MuiInputBase-input": {
//                     color: theme.palette.text.primary,
//                   },
//                 }}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 label="Skill Sets"
//                 name="skill_sets"
//                 value={employeeWorkExperience.skill_sets}
//                 onChange={handleChange}
//                 fullWidth
//                 required
//                 InputLabelProps={{
//                   shrink: true,
//                   sx: {
//                     color: theme.palette.mode === "dark" ? "#fff" : "inherit",
//                     "&.Mui-focused": {
//                       color: theme.palette.mode === "dark" ? "#fff" : theme.palette.primary.main,
//                     },
//                   },
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     borderRadius: 2,
//                     backgroundColor:
//                       theme.palette.mode === "dark" ? "" : theme.palette.background.default,
//                     color: theme.palette.text.primary,
              
//                     // Active (focused) background color change
//                     "&.Mui-focused": {
//                       backgroundColor: theme.palette.mode === "dark" ? "hsla(180, 17.20%, 25.10%, 0.92)" : "#f5f5f5",
//                     },
              
//                     "& fieldset": {
//                       borderColor:
//                         theme.palette.mode === "dark"
//                           ? ""
//                           : "#ccc",
//                     },
//                     "&:hover fieldset": {
//                       borderColor: theme.palette.primary.main,
//                     },
//                     "&.Mui-focused fieldset": {
//                       borderColor: theme.palette.mode === "dark" ? "white" : "#f5f5f5",
//                     },
//                   },
//                   "& .MuiInputBase-input": {
//                     color: theme.palette.text.primary,
//                   },
//                 }}
//               />
//             </Grid>

//             {successMessage && (
//               <Grid item xs={12}>
//                 <Typography color="green" align="center">
//                   {successMessage}
//                 </Typography>
//               </Grid>
//             )}

//             {errorMessage && (
//               <Grid item xs={12}>
//                 <Typography color="error" align="center">
//                   {errorMessage}
//                 </Typography>
//               </Grid>
//             )}
//           </Grid>
//         </form>
//       </Box>
//     </Container>
//   );
// });

// export default AppEmployeeWorkExperience;


import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import {
  Container, Grid, CardContent, TextField, Typography, Box, Button,
  useTheme
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { db } from "../../../../../firebaseConfig.js";
import { doc, updateDoc } from 'firebase/firestore';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { useParams } from "react-router-dom";
import { tokens } from "../../../../../theme";
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from "@mui/material/IconButton";

const AppEmployeeWorkExperience = forwardRef(({ employeeId: propEmployeeId },ref) => {
  const theme = useTheme();
   const colors = tokens(theme.palette.mode);
  const { employeeId: paramEmployeeId } = useParams();
  const employeeId = propEmployeeId || paramEmployeeId;
  const isEditMode = Boolean(employeeId);
  const [employeeWorkExperience, setEmployeeWorkExperience] = useState({
    corporate_email_id: '',
    professional_reference1: '',
    professional_reference1_contact_number: '',
    professional_reference2: '',
    professional_reference2_contact_number: '',
    professional_reference1_email: '',
    professional_reference2_email: '',
    skill_sets: '',
    uploaded_files: {
      experience_certificate: '',
      relieving_letter: '',
    }
  });
   const [selectedFiles, setSelectedFiles] = useState({
    experience_certificate: null,
    relieving_letter: null,
  });

  const [errorMessage, setErrorMessage] = useState(""); 
  const [fieldErrors, setFieldErrors] = useState({});  


  useEffect(() => {
    if (!isEditMode) return; 

    const fetchWorkExperience = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/work-experience/${employeeId}`);
        const data = await response.json();

        if (response.ok) {
          setEmployeeWorkExperience({
            corporate_email_id: data.corporate_email_id || '',
            professional_reference1: data.professional_reference1 || '',
            professional_reference1_contact_number: data.professional_reference1_contact_number || '',
            professional_reference1_email: data.professional_reference1_email || '',
            professional_reference2: data.professional_reference2 || '',
            professional_reference2_contact_number: data.professional_reference2_contact_number || '',
            professional_reference2_email: data.professional_reference2_email || '',
            skill_sets: data.skill_sets || '',
            uploaded_files: {
              experience_certificate: data.uploaded_files?.experience_certificate || '',
              relieving_letter: data.uploaded_files?.relieving_letter || '',
            }
          });
        } else {
          setErrorMessage("Failed to fetch existing data.");
        }
      } catch (error) {
        setErrorMessage("Error fetching data.");
      }
    };

    fetchWorkExperience();
  }, [employeeId, isEditMode]);

  const handleFileChange = (type) => (e) => {
    setSelectedFiles((prev) => ({ ...prev, [type]: e.target.files[0] }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEmployeeWorkExperience((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  
    const validateForm = () => {
      const newErrors = {};

      const ref1Name = employeeWorkExperience.professional_reference1?.trim();
      const ref1Contact = employeeWorkExperience.professional_reference1_contact_number;
      const ref1Email = employeeWorkExperience.professional_reference1_email;

      const ref2Name = employeeWorkExperience.professional_reference2?.trim();
      const ref2Contact = employeeWorkExperience.professional_reference2_contact_number;
      const ref2Email = employeeWorkExperience.professional_reference2_email;

      // Reference 1 is required
      if (!ref1Name) {
        newErrors.professional_reference1 = "Reference 1 name is required.";
      }

      if (!ref1Name && !ref2Name) {
        newErrors.form = "At least one professional reference must be filled.";
      }

      const validateReference = (prefix, name, contact, email, isRequired) => {
        if (name) {
          if (!/^[A-Za-z\s]+$/.test(name)) {
            newErrors[prefix] = "Only alphabets allowed.";
          }

          if (contact && !/^\d{10}$/.test(contact)) {
            newErrors[`${prefix}_contact_number`] = "Enter valid 10-digit number.";
          }

          if (email && !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
            newErrors[`${prefix}_email`] = "Enter valid email.";
          }
        } else {
          if (isRequired) {
            // If required, validate missing contact/email only if they're present
            if (contact || email) {
              newErrors[prefix] = "Name is required if contact/email is filled.";
            }
          }
          // If not required (like Reference 2), skip all validation if name is empty
        }
      };

      validateReference("professional_reference1", ref1Name, ref1Contact, ref1Email, true);
      validateReference("professional_reference2", ref2Name, ref2Contact, ref2Email, false); // Fully optional

      setFieldErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };


    const handleSave = async (corporateEmail) => {
      try {
        const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user?.stsTokenManager?.accessToken;

        const formData = new FormData();
        formData.append("corporate_email_id", corporateEmail);
        formData.append("skill_sets", employeeWorkExperience.skill_sets || '');
        formData.append("professional_reference1", employeeWorkExperience.professional_reference1);
        formData.append("professional_reference1_contact_number", employeeWorkExperience.professional_reference1_contact_number);
        formData.append("professional_reference1_email", employeeWorkExperience.professional_reference1_email);
        formData.append("professional_reference2", employeeWorkExperience.professional_reference2);
        formData.append("professional_reference2_contact_number", employeeWorkExperience.professional_reference2_contact_number);
        formData.append("professional_reference2_email", employeeWorkExperience.professional_reference2_email);

        // Append uploaded files only if selected
        if (selectedFiles.experience_certificate) {
          formData.append("experience_certificate", selectedFiles.experience_certificate);
        }
        if (selectedFiles.relieving_letter) {
          formData.append("relieving_letter", selectedFiles.relieving_letter);
        }

        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/add-employee-work-experience`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            // DO NOT set 'Content-Type'; let the browser set it with the right boundary
          },
          body: formData,
        });

        if (!response.ok) throw new Error("Failed to add work experience.");

        setErrorMessage("");
        console.log("Successfully added work experience.");
      } catch (error) {
        setErrorMessage("Failed to add work experience.");
        console.error(error);
      }
    };

    const handleDeleteFile = async (type) => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/delete-work-experience-file/${employeeId}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_HRM_API_KEY,
          },
          body: JSON.stringify({ file_type: type }),
        });

        const result = await res.json();

        if (res.ok) {
          setEmployeeWorkExperience((prev) => ({
            ...prev,
            uploaded_files: {
              ...prev.uploaded_files,
              [type]: '',
            }
          }));
          setSelectedFiles((prev) => ({
            ...prev,
            [type]: null,
          }));
        } else {
          alert(result.message || "Failed to delete file.");
        }
      } catch (err) {
        console.error("Delete error", err);
        alert("Error deleting file.");
      }
    };

    const handleUpdate = async () => {
      try {
        const formData = new FormData();
        for (const key in employeeWorkExperience) {
          if (typeof employeeWorkExperience[key] === "string") {
            formData.append(key, employeeWorkExperience[key]);
          }
        }

        // Append file if selected
        if (selectedFiles.experience_certificate) {
          formData.append("experience_certificate", selectedFiles.experience_certificate);
        }

        if (selectedFiles.relieving_letter) {
          formData.append("relieving_letter", selectedFiles.relieving_letter);
        }

        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/update-work-experience-details/${employeeId}`, {
          method: "PUT",
          body: formData,
          headers: {
            "x-api-key": process.env.REACT_APP_HRM_API_KEY,
          },
        });

        const result = await response.json();

        if (response.ok) {
          if (result.updated === false || result.message === "No changes detected.") {
            setErrorMessage(""); 
            console.log("No changes detected. Work experience remains the same.");
            return true; 
          } else {
            setErrorMessage("");
            return true; 
            
          }
        } else {
          setErrorMessage(result.message || "Update failed.");
          return false;
        }
      } catch (error) {
        setErrorMessage("Update failed.");
        console.error(error);
      }
    };


  useImperativeHandle(ref, () => ({
    savedata: async (corporateEmail) => {
      try {
        if (employeeId) {
          await handleUpdate();
        } else {
          await handleSave(corporateEmail);
        }
        return true;
      } catch (err) {
        console.error("Error in workExperience save:", err);
        return false;
      }

    },
    update: async () => {
      try {
          const result = await handleUpdate(); 
          return result; 
      } catch (err) {
        console.error("Error in workExperience update:", err);
        return false;
      }
    },
      validate: validateForm,
  }), [employeeId, employeeWorkExperience, selectedFiles]);


  const customInputSx = {
      borderRadius: "8px",
      backgroundColor: "transparent",
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa"
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important"
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important"
      }
    };

    const customLabelSx = {
      fontSize: "18px",
      fontWeight: "bold",
      color: colors.grey[100],
      "&.Mui-focused": {
        color: colors.grey[100]
      },
      "&.MuiInputLabel-shrink": {
        color: colors.grey[100]
      }
    };

  return (
    <Container sx={{ maxWidth: "600px", mt: 5, p: 3, borderRadius: 2, textAlign: "center" }}>
      <CardContent>
        {["experience_certificate", "relieving_letter"].map((type) => (
          <Box key={type} display="flex" flexDirection="column" alignItems="center" mb={3}>
            
            <input
              id={`upload-${type}`}
              type="file"
              style={{ display: 'none' }}
              onChange={handleFileChange(type)}
            />
            <Button
              variant="outlined"
              startIcon={<CloudUploadIcon />}
              onClick={() => document.getElementById(`upload-${type}`).click()}
              sx={{
                padding: "10px",
                borderRadius: "5px",
                border: "1px dashed #007bff",
                color: customLabelSx.color,
                cursor: "pointer"
              }}
            >
              Upload {type.replace("_", " ")}
            </Button>

            {selectedFiles[type] ? (
              <>
                <Typography variant="body2" color="green" mt={1}>
                  Selected: {selectedFiles[type].name}
                </Typography>
                <Box display="flex" alignItems="center" gap={1}>
                  <a
                    href={URL.createObjectURL(selectedFiles[type])}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "blue", fontSize: "0.9rem" }}
                  >
                    View {type.replace("_", " ")}
                  </a>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => {
                      setSelectedFiles((prev) => ({ ...prev, [type]: null }));
                    }}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              </>
            ) : employeeWorkExperience.uploaded_files?.[type] ? (
              <>
                <Typography variant="body2" color="green" mt={1}>
                  Uploaded: {type.replace("_", " ")}
                </Typography>
                <Box display="flex" alignItems="center" gap={1}>
                  <a
                    href={employeeWorkExperience.uploaded_files[type]}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "blue", fontSize: "0.9rem" }}
                  >
                    View {type.replace("_", " ")}
                  </a>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => handleDeleteFile(type)} // 👈 your reusable delete function
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              </>
            ) : null}
           
          </Box>
        ))}

        <Grid container spacing={2}>
          {[
            { label: "Professional Reference 1 *", name: "professional_reference1" },
            { label: "Reference Contact *", name: "professional_reference1_contact_number" },
            { label: "Reference Email *", name: "professional_reference1_email" },
            { label: "Professional Reference 2", name: "professional_reference2" },
            { label: "Reference Contact", name: "professional_reference2_contact_number" },
            { label: "Reference Email", name: "professional_reference2_email" },
            { label: "Skill Sets", name: "skill_sets" }
          ].map((field) => (
            <Grid item xs={12} sm={6} md={4} key={field.name}>
              <TextField
                fullWidth
                label={field.label}
                name={field.name}
                value={employeeWorkExperience[field.name] || ""}
                onChange={handleChange}
                variant="outlined"
                error={Boolean(fieldErrors[field.name])}        
                helperText={fieldErrors[field.name] || ''}   
                InputLabelProps={{
                  shrink: true,
                  sx: customLabelSx,
                }}
                sx={{
                  ...customInputSx,
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    backgroundColor: theme.palette.mode === "dark" ? "" : theme.palette.background.default,
                    color: theme.palette.text.primary,
                    "&.Mui-focused": {
                      backgroundColor: theme.palette.mode === "dark"
                        ? "hsla(180, 17.20%, 25.10%, 0.92)"
                        : "#f5f5f5",
                    },
                    "& fieldset": {
                      borderColor: theme.palette.mode === "dark" ? "" : "#ccc",
                    },
                    "&:hover fieldset": {
                      borderColor: theme.palette.primary.main,
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: theme.palette.mode === "dark" ? "white" : "#f5f5f5",
                    },
                  },
                  "& .MuiInputBase-input": {
                    color: theme.palette.text.primary,
                  },
                }}
              />
            </Grid>
          ))}
        </Grid>

      </CardContent>
    </Container>
  );
});

export default AppEmployeeWorkExperience;
